import React, { useState } from 'react';
import '@availity/yup';
import { MarketplaceOpportunity } from '../../../slices/marketplace/opportunity/models/opportunity';
import { Button, ModalBody, ModalHeader } from 'reactstrap';
import BootstrapTable from '../../../components/react-bootstrap-table-next/react-bootstrap-table2';
import Rodal from '../../../components/Rodal/Rodal';
import { createPortal } from 'react-dom';
import { LegalEntityTypeList } from '../../../slices/marketplace/timeline/models/enums/legal-enity-type';
import { MarketplaceOpportunityStatusList } from '../../../slices/marketplace/opportunity/models/opportunity-status';

export interface AddAccessToOpportunitiesModal {
    isVisible: boolean;
    setIsVisible: (isVisible: boolean) => void;
    opportunities: MarketplaceOpportunity[];
    AddAccessToOpportunities: (selectedIds: number[]) => void;
}

export const AddAccessToOpportunitiesModal = (
    props: AddAccessToOpportunitiesModal
) => {
    const [selectedIds, setSelectedIds] = useState<number[]>([]);

    const getColumns = () => [
        {
            dataField: 'id',
            text: '',
            headerFormatter: () => (
                <input
                    type="checkbox"
                    checked={isAnySelected()}
                    onChange={(e) => onSelectAll(e.target.checked)}
                />
            ),
            formatter: (_: any, row: MarketplaceOpportunity) => {
                return (
                    <input
                        type="checkbox"
                        checked={isChecked(row.opportunityId)}
                        onChange={(e) =>
                            onSelect(row.opportunityId, e.target.checked)
                        }
                    />
                );
            },
            headerStyle: { width: '40px' },
        },
        { dataField: 'opportunityId', text: 'Opp Id', sort: false },
        {
            dataField: 'id',
            text: 'Practice Name',
            sort: false,
            formatter: (_: any, row: MarketplaceOpportunity) =>
                row.practices.map((p) => p.entityName).join(', '),
        },
        {
            dataField: 'practiceType',
            text: 'Service Focus',
            sort: false,
            formatter: (_: any, row: MarketplaceOpportunity) =>
                row.practices
                    .map(
                        (p) =>
                            LegalEntityTypeList.find(
                                (x) => x.id === p.entityType
                            )?.name
                    )
                    .join(', '),
        },
        {
            dataField: 'fteDvms',
            text: 'Fte Dvms',
            sort: false,
            formatter: (_: any, row: MarketplaceOpportunity) =>
                row.practices
                    .map((p) => p.fteDvms)
                    .reduce((acc, val) => acc + val, 0),
        },
        {
            dataField: 'state',
            text: 'State',
            sort: false,
            formatter: (_: any, row: MarketplaceOpportunity) =>
                row.practices.map((p) => p.stateOfRegistration).join(', '),
        },
        {
            dataField: 'status',
            text: 'Status',
            sort: false,
            formatter: (_: any, row: MarketplaceOpportunity) =>
                MarketplaceOpportunityStatusList.find(
                    (x) => x.id === row.status
                )?.name,
        },
    ];
    
    const AddAccessToOpportunities = () => {
        props.AddAccessToOpportunities(selectedIds);
        props.setIsVisible(false);
    }

    const isChecked = (id: number) => {
        return selectedIds.includes(id);
    };

    const isAnySelected = () => {
        return selectedIds.length > 0;
    };

    const onSelectAll = (isSelect: boolean) => {
        setSelectedIds(
            isSelect ? props.opportunities.map((r) => r.opportunityId) : []
        );
    };

    const onSelect = (id: number, isSelect: boolean) => {
        setSelectedIds((prev) =>
            isSelect ? [...prev, id] : prev.filter((x) => x !== id)
        );
    };

    return createPortal(
        <Rodal
            visible={props.isVisible}
            onClose={() => {
                props.setIsVisible(false);
            }}
            width={900}
            className="add-access-to-opportunity-modal-wrapper">
            <ModalHeader>Add Access Rights</ModalHeader>
            <ModalBody className="add-access-to-opportunity-modal">
                <div className="table-responsive">
                    <BootstrapTable
                        key={selectedIds.join(',')}
                        keyField="id"
                        data={props.opportunities}
                        columns={getColumns()}
                        bordered
                        striped
                        noDataIndication="No opportunities available."
                        wrapperClasses="table-bordered table-striped"
                    />
                </div>
                <div className="mt-2">
                    <Button
                        color="primary"
                        className='small-btn'
                        onClick={() => AddAccessToOpportunities()}
                        disabled={selectedIds.length === 0}>
                        Confirm
                    </Button>
                </div>
            </ModalBody>
        </Rodal>,
        document.body,
        'add-access-to-opportunity-modal-wrapper'
    );
};
